<template>
  <Transition name="global-loading-fade">
    <div v-if="visible" class="global-loading" role="progressbar" :aria-label="t('common.loadingPage')">
      <div class="global-loading__bar" :style="{ width: progress + '%' }" />
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
import { ref, watch, onBeforeUnmount } from 'vue'
import { storeToRefs } from 'pinia'
import { useUIStore } from '@/stores/ui.store'

const uiStore = useUIStore()
const { globalLoading } = storeToRefs(uiStore)

const visible = ref(false)
const progress = ref(0)

let trickleTimer: ReturnType<typeof setInterval> | null = null
let doneTimer: ReturnType<typeof setTimeout> | null = null

function clearTimers() {
  if (trickleTimer) {
    clearInterval(trickleTimer)
    trickleTimer = null
  }
  if (doneTimer) {
    clearTimeout(doneTimer)
    doneTimer = null
  }
}

function start() {
  clearTimers()
  visible.value = true
  progress.value = 12
  // İlerlemeyi yavaşça %90'a kadar tırmandır — gerçek bitiş beklenirken.
  trickleTimer = setInterval(() => {
    if (progress.value < 90) {
      const remaining = 90 - progress.value
      progress.value += Math.max(0.5, remaining * 0.12)
    }
  }, 200)
}

function finish() {
  clearTimers()
  progress.value = 100
  doneTimer = setTimeout(() => {
    visible.value = false
    progress.value = 0
  }, 300)
}

watch(globalLoading, (loading) => {
  if (loading) start()
  else if (visible.value) finish()
})

onBeforeUnmount(clearTimers)
</script>

<style scoped>
.global-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  z-index: 9999;
  pointer-events: none;
}

.global-loading__bar {
  height: 100%;
  background: linear-gradient(90deg, var(--primary-500), var(--primary-700));
  box-shadow: 0 0 8px 0 var(--primary-500);
  border-radius: 0 2px 2px 0;
  transition: width 0.2s ease;
}

.global-loading-fade-leave-active {
  transition: opacity 0.3s ease;
}

.global-loading-fade-leave-to {
  opacity: 0;
}
</style>
